import { FC } from "react";
import { RouteComponentProps } from "react-router-dom";
import AbsenceType from "./AbsenceType";

const AbsenceTypeEdit: FC<RouteComponentProps<{ absenceTypeId?: string }>> = ({
  match,
}) => {
  const { absenceTypeId } = match.params;

  return <AbsenceType absenceTypeId={absenceTypeId} />;
};

export default AbsenceTypeEdit;
